import React from 'react'

const AuthorSuggestions = ({ authorSuggestion, styles }) => (
  <p className={styles.authorText}>
    {'We found an author by that name: '}
    {authorSuggestion ? (
      <a className={styles.authorLink} href={authorSuggestion.url}>
        {authorSuggestion.username}
      </a>
    ) : null}
  </p>
)

export default AuthorSuggestions



// WEBPACK FOOTER //
// ./client/components/searchHeader/authorSuggestions.js